import ProductForm from '../components/ProductForm';

export default function AddProduct() {
  return <ProductForm />;
}
